import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

const CryptoPriceChange = ({ value, valueStyle }) => {
    return (
        <span
            className={`flex items-center text-sm font-medium ${
                value >= 0 ? 'text-[#00ff00]' : 'text-[#ff0000]'
            }`}>
            {value > 0 && <ArrowDropUpIcon size={14} />}
            {value < 0 && <ArrowDropDownIcon size={14} />}
            <span className={valueStyle ? valueStyle : `text-text`}>
                {Math.abs(value).toFixed(3)}%
            </span>
        </span>
    );
};

export default CryptoPriceChange;
